let session = {

	navArgs: {}
};

export default session;